module.exports = __webpack_public_path__ + "img/building-solid.f8718b7e.svg";